export default "__VITE_ASSET__GO$WYYPg__"